import * as React from 'react';
import i18n from 'i18next';
import { action } from 'mobx';

// components
import LabelGroup from 'components/_UI/Forms/LabelGroup/LabelGroup';
import ActionSelectGroup from 'components/_UI/Forms/Actions/ActionSelectGroup';
import ActionSliderGroup from 'components/_UI/Forms/Actions/ActionSliderGroup';
import ActionCheckboxSliderColorSwatchGroup from 'components/_UI/Forms/Actions/ActionCheckboxSliderColorSwatchGroup';
import { colorModeOptions } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { NativeStylingOptions } from '@sprinklr/display-builder/widgets/PostsWidget/types';

function NativeStylingTunableBlocks(
    nativeStyling: Omit<NativeStylingOptions, 'enabled'> & { enabled?: boolean }
) {
    if (!nativeStyling) {
        return null;
    }
    return (
        <>
            <ActionSliderGroup
                data-testid='slider-sizing-native-styling-tunables-blocks'
                label={i18n.t('Sizing')}
                option={nativeStyling}
                value={'fontScale'}
                showValue
                min={0}
                max={100}
            />

            <LabelGroup label={i18n.t('Color Mode')}>
                <ActionSelectGroup
                    data-testid='select-color-mode-native0styling-tunables-blocks'
                    options={colorModeOptions}
                    option={nativeStyling}
                    value='colorMode'
                />
            </LabelGroup>

            <ActionCheckboxSliderColorSwatchGroup
                data-testid='slider-border-native-styling-tunables-blocks'
                label={i18n.t('Border')}
                showValue
                checkbox={{
                    checked: nativeStyling.border.enabled,
                    value: 'enabled',
                    option: nativeStyling.border,
                }}
                slider={{
                    min: 0,
                    max: 100,
                    value: 'size',
                    option: nativeStyling.border,
                }}
                colorSwatch={{
                    option: nativeStyling.border,
                    value: 'color',
                    color: nativeStyling.border.color,
                    onChange: action(
                        ({ rgb: { r, g, b, a } }) =>
                            (nativeStyling.border.color = `rgba(${r}, ${g}, ${b}, ${a})`)
                    ),
                    secondaryIcon: nativeStyling.border.color ? 'icon-undo' : undefined,
                }}
            />

            <ActionCheckboxSliderColorSwatchGroup
                data-testid='slider-drop-shadow-native-styling-tunables-blocks'
                label={i18n.t('Drop Shadow')}
                showValue
                checkbox={{
                    checked: nativeStyling.shadow.enabled,
                    value: 'enabled',
                    option: nativeStyling.shadow,
                }}
                slider={{
                    min: 0,
                    max: 100,
                    value: 'size',
                    option: nativeStyling.shadow,
                }}
                colorSwatch={{
                    option: nativeStyling.shadow,
                    value: 'color',
                    secondaryIcon: nativeStyling.shadow.color ? 'icon-undo' : undefined,
                    color: nativeStyling.shadow.color,
                    onChange: action(
                        ({ rgb: { r, g, b, a } }) =>
                            (nativeStyling.shadow.color = `rgba(${r}, ${g}, ${b}, ${a})`)
                    ),
                }}
            />
        </>
    );
}

export { NativeStylingTunableBlocks };
